module.exports = __webpack_public_path__ + "img/player_stats_bg.2a8f87d4.png";